import { createContext, useContext, type ReactNode } from 'react'

export type ShiftAuthoring = {
  eventId: string
  dates: string[]
  roles: string[]
  timeZone: string | null
  onChange: () => void
}

const ShiftAuthoringContext = createContext<ShiftAuthoring | null>(null)

export function ShiftAuthoringProvider({ value, children }: { value: ShiftAuthoring; children: ReactNode }) {
  return <ShiftAuthoringContext.Provider value={value}>{children}</ShiftAuthoringContext.Provider>
}

export function useShiftAuthoring(): ShiftAuthoring {
  const context = useContext(ShiftAuthoringContext)
  if (!context) throw new Error('useShiftAuthoring must be used within a ShiftAuthoringProvider')
  return context
}

export function useEventTimeZone(): string | null {
  return useContext(ShiftAuthoringContext)?.timeZone ?? null
}
